import React from "react";
import { MdLocationPin } from "react-icons/md";
import "./ResumeCardItem.scss";

const ResumeCardItem = (props) => {
  const { title, location, year } = props;
  return (
    <div
      data-aos="fade-up-right"
      className="col-lg-6 col-md-6 col-sm-12 resume-card"
    >
      <h4 data-aos="fade-right">{title}</h4>
      <div className="card-inner">
        {" "}
        <div className="location">
          <MdLocationPin />
          <span>{location}</span>
        </div>
        <span className="year">{year}</span>
        <div className="text"></div>
      </div>
    </div>
  );
};

export default ResumeCardItem;
